import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const Login = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const timeout = searchParams.get('timeout');

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async () => {
    try {
      await login();
    } catch {
      // Login redirect will handle the error
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="card max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-admin-text mb-2">管理コンソール</h1>
          <p className="text-admin-textLight">Hakusensha Enet</p>
        </div>

        {timeout && (
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded mb-6">
            <p className="text-sm">
              セッションがタイムアウトしました。再度ログインしてください。
            </p>
          </div>
        )}

        <div className="mb-6">
          <p className="text-sm text-admin-textLight text-center mb-4">
            Auth0を使用して安全にログインします
          </p>
        </div>

        <button onClick={handleLogin} className="w-full btn-primary py-3 text-lg">
          ログイン
        </button>

        <div className="mt-6 text-center text-xs text-admin-textLight">
          <p>セッション有効期限: 8時間</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
